import { LineString } from "geojson";
import { z } from "zod";

import { fetchWithError, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams, lineToWkt } from "@nens/shared-utils";

import { exportSchema } from "./timeseries_export";

export const rasterLineSchema = z.object({
  results: z.array(z.tuple([z.number(), z.number().nullable()])),
});

export type RasterLine = z.infer<typeof rasterLineSchema>;

export function useRasterLine(uuid: string, geometry: LineString) {
  const geom = lineToWkt(geometry);
  const url = combineUrlAndParams(`/api/v4/rasters/${uuid}/line/`, { geom });
  return useParsedQuery<RasterLine>(
    ["lizard-api-v4", "rasterline", url],
    () => fetchWithError(url),
    (json: unknown) => rasterLineSchema.parse(json)
  );
}

export async function fetchRasterLine(uuid: string, geometry: LineString) {
  const geom = lineToWkt(geometry);
  const url = combineUrlAndParams(`/api/v4/rasters/${uuid}/line/`, { geom });

  const json = await fetchWithError(url);
  return rasterLineSchema.parse(json).results;
}

export async function fetchRasterLineAsync(uuid: string, geometry: LineString) {
  const geom = lineToWkt(geometry);
  const url = combineUrlAndParams(`/api/v4/rasters/${uuid}/line/`, { async: true, geom });

  const json = await fetchWithError(url);
  return exportSchema.parse(json);
}
